<script>
  import moment from "moment";
  import RepDeliveryDates from "./RepDeliveryDates.svelte";
  import { DeliveryDateCalculator } from "@shared/services/delivery_date_calculator.js";
  import OrderDeliveryStore from "@shared/svelte/Stores/OrderDeliveryStore";

  export let order;
  export let onSelectDate;
  export let integratedDelivery;

  const deliveryDateCalc = new DeliveryDateCalculator(order);

  function usesIntegratedDates(order) {
    return (
      deliveryDateCalc.usesIntegratedDeliveryDates &&
      (!order.distributor.is_rolling_out_integrated_orders ||
        (order.distributor.is_rolling_out_integrated_orders &&
          order.retailer.is_part_of_integrated_orders_rollout))
    );
  }
  const integratedDistributor = usesIntegratedDates(order);

  let selectedDate;

  let routes = [];
  if (integratedDistributor) {
    if (deliveryDateCalc.deliveryDateMode == "multiple") {
      routes = _.get(order.distributor_account_config, "routes", []);
    } else {
      routes = [_.get(order.distributor_account_config, "route")];
    }

    // Remove empty/null/undefined elements
    routes = routes.filter(function (e) {
      return e;
    });
  }

  function getNextCutoffDate() {
    let date = _.get(order.distributor_account_config, "cutoff_time");
    return date ? moment(date) : deliveryDateCalc.nextCutoffDate;
  }
  let nextCutoffDate = getNextCutoffDate();

  function getIntegratedDeliveryDates() {
    if (!integratedDistributor) {
      return null;
    }

    let dates = deliveryDateCalc.integratedDeliveryDates();
    return dates.length > 0 ? dates : null;
  }
  let integratedDeliveryDates = getIntegratedDeliveryDates();

  let availableDates = order.delivery_dates.filter(date => validWithNextCutoff(date));
  // Use distributor-provided actual delivery dates if available
  if (integratedDeliveryDates && integratedDeliveryDates.length > 0) {
    // note: for JJT we want to only display the first available date
    availableDates = integratedDeliveryDates.slice(0, 1);
    if (!selectedDate) {
      selectedDate = availableDates[0].date;
      OrderDeliveryStore.set(selectedDate);
    }
  }

  // dates represents the set of delivery dates that are considered appropriate for this retailer
  // as opposed to availableDates, which is a list of all dates
  let dates = availableDates;
  if (integratedDistributor) {
    availableDates = availableDates.map(date =>
      validIntegratedDate(date) ? { ...date, integrated: true } : { ...date }
    );

    let integratedDates = availableDates.filter(date => date.integrated);
    if (integratedDates.length == 0) {
      dates = availableDates;
    } else {
      dates = integratedDates;
      if (!selectedDate) {
        selectedDate = integratedDates[0].date;
        OrderDeliveryStore.set(selectedDate);
      }
    }
  }

  if (selectedDate && integratedDelivery) {
    onSelectDate(selectedDate);
  }

  function validWithNextCutoff(date) {
    if (!nextCutoffDate.isValid()) return true;

    // check if Monday deliver is enabled and day is monday
    let isMondayCutoff = nextCutoffDate.day() === 1;
    let todayIsMonday = moment().day() === 1;

    if (order.distributor.monday_delivery_on_weekend_orders && isMondayCutoff && !todayIsMonday) {
      return moment(date.date + "T21:00:00").isSameOrAfter(nextCutoffDate);
    }

    return moment(date.date).isSameOrAfter(nextCutoffDate);
  }

  function validIntegratedDate(date) {
    return deliveryDateCalc.validIntegratedDate(moment(date.date));
  }

  function handleDateClick(date, offDayWarning) {
    let newDate = date;
    if (newDate === selectedDate) {
      newDate = null;
    }

    selectedDate = newDate;
    onSelectDate(newDate, offDayWarning);
    OrderDeliveryStore.set(newDate);
  }

  function handleIntegratedDateSelect(event) {
    const val = event.target.value;
    handleDateClick(val, val && !validIntegratedDate({ date: val }));
    OrderDeliveryStore.set(val);
  }

</script>

<RepDeliveryDates
  {selectedDate}
  {dates}
  {availableDates}
  {routes}
  {integratedDelivery}
  {handleIntegratedDateSelect}
  handleDateSelect={onSelectDate}
/>
